export default __webpack_public_path__ + "static/media/bg.8288dd58.svg";